import styled, { isPropValid } from '@mint-lib/styled';
import AutocompleteM, {
  AutocompleteProps as AutocompletePropsM,
} from '@mui/material/Autocomplete';
import { TooltipProps as TooltipPropsM } from '@mui/material/Tooltip';

import Icon from '../Icon/Icon.jsx';

export type AutocompleteProps<
  T,
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined,
> = AutocompletePropsM<T, Multiple, DisableClearable, FreeSolo> & {
  /**
   * Tooltip props
   */
  TooltipProps?: Partial<TooltipPropsM>;
};
/**
 * @deprecated Use Autocomplete from @mint-lib/tw-components/patterns instead
 */
function Autocomplete<
  T,
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined,
>({
  TooltipProps,
  ...MuiAutocompleteProps
}: AutocompleteProps<T, Multiple, DisableClearable, FreeSolo>) {
  return (
    <Wrapper fullWidth={MuiAutocompleteProps.fullWidth}>
      <AutocompleteM
        {...MuiAutocompleteProps}
        clearIcon={<Icon component="Close" />}
        popupIcon={<Icon component="ChevronDown" />}
        className={`${
          MuiAutocompleteProps.readOnly ? 'read-only-autocomplete' : ''
        }`}
        componentsProps={{
          popupIndicator: {
            sx: {
              display: MuiAutocompleteProps.readOnly ? 'none' : 'inline-flex',
            },
          },
          paper: {
            sx: {
              marginTop: '4px',
              borderRadius: '4px',
            },
          },
        }}
      />
    </Wrapper>
  );
}
export default Autocomplete;
const Wrapper = styled('div', { shouldForwardProp: isPropValid })<{
  fullWidth: boolean | undefined;
}>`
  align-items: center;
  display: flex;
  gap: 8px;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
`;
